module.exports = __webpack_public_path__ + "static/media/yellowTheme-boy.fef8bd8f.svg";